import { FC, useState } from "react";
import { useScroll } from "../../../store/scroll/useScroll";
import Nav from "../../common/nav";
import Filters from "../../filters";
import FixturesList from "../../fixturesList";

import styles from "./fixturesPage.module.scss";

export interface FixturesProps {}

const FixturesPage: FC<FixturesProps> = () => {
    const [filtersOpen, setFiltersOpen] = useState(false);
    const { setEnabled } = useScroll();

    const handleToggleFiltersOpen = () => {
        setFiltersOpen(!filtersOpen);
        setEnabled(filtersOpen);
    };

    return (
        <div className={styles.parentContainer}>
            <div className={styles.childContainer}>
                <Nav classes={styles.nav} />
                <div className={styles.content}>
                    <Filters onToggleFiltersOpen={handleToggleFiltersOpen} open={filtersOpen}></Filters>
                    <FixturesList onToggleFiltersOpen={handleToggleFiltersOpen} />
                </div>
            </div>
        </div>
    );
};

export default FixturesPage;
